export const tradingEvaluationTime = -10;
